import validator from 'validator';

export const AddCustomPlansBenefitsValidation = (data) => {
  const errors = {};

  if (validator.isEmpty(data?.name?.trim())) {
    errors.name = '*Name is required';
  }

  if (data?.email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emails = data?.email?.split(',').map((email) => email.trim());
    const invalidEmails = emails.filter((email) => email && !regex.test(email));
    if (invalidEmails.length > 0) {
      errors.email = 'Invalid email address(es)';
    }
  } else {
    errors.email = '*Email is required.';
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};
